import { FC } from 'react'
import { Stack, Typography } from '@mui/material'
import { EmbedSessionProvider } from 'utils/embedSession/embedSession'
import { useEmbedCrm } from 'utils/embedSession/useEmbedCrm'
import { useTranslation } from 'react-i18next'

interface Props {
  /** The CRM the page was opened for, when it is known without a session (the session itself has failed). */
  provider?: EmbedSessionProvider
}

export const EmbedSessionError: FC<Props> = ({ provider }) => {
  const { t } = useTranslation(['embed'])
  const { crmName } = useEmbedCrm(provider)

  return (
    <Stack spacing={1} alignItems='center' justifyContent='center' sx={{ height: '100%', p: 4, textAlign: 'center' }}>
      <Typography variant='h6'>{t('session_error.title')}</Typography>
      <Typography variant='body2' color='text.secondary'>{t('session_error.message_crm', { crm: crmName })}</Typography>
    </Stack>
  )
}

export default EmbedSessionError
